module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDE1IDIyIj4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHBhdGggc3Ryb2tlPSIjRkVGRUZFIiBzdHJva2Utd2lkdGg9IjEuNSIgZD0iTTEuNTE3IDMuODdWMS41MTdoMTEuNzY1VjMuODdsLTQuNzUgNy4wOCA0Ljc1IDYuOTk0djIuNDRIMS41MTd2LTIuNDRsNC43MDYtNi45OTN6Ii8+CiAgICA8cGF0aCBmaWxsPSIjRkVGRUZFIiBkPSJNMy4yNTMgMy4zNDZ2LS4wOTNoOC4yOTN2LjA5TDcuMzggOS41NTUiLz4KICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/common/components/icons/hour-glass-high.svg
// module id = 1783
// module chunks = 2